module.exports = __webpack_public_path__ + "img/蔚县煤炭.9507620e.jpg";